"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCORE = exports.ROLLUP = exports.EQUATION = exports.CALCULATION = exports.TEXTAREA = exports.TEXT = exports.SELECT = exports.RADIO = exports.NUMBER = exports.FILE = exports.DATE = exports.CHECKBOX = exports.BOOLEAN_CHECKBOX = void 0;
var BOOLEAN_CHECKBOX = 'booleancheckbox';
exports.BOOLEAN_CHECKBOX = BOOLEAN_CHECKBOX;
var CHECKBOX = 'checkbox';
exports.CHECKBOX = CHECKBOX;
var DATE = 'date';
exports.DATE = DATE;
var FILE = 'file';
exports.FILE = FILE;
var NUMBER = 'number';
exports.NUMBER = NUMBER;
var RADIO = 'radio';
exports.RADIO = RADIO;
var SELECT = 'select';
exports.SELECT = SELECT;
var TEXT = 'text';
exports.TEXT = TEXT;
var TEXTAREA = 'textarea';
exports.TEXTAREA = TEXTAREA;
var CALCULATION = 'calculation';
exports.CALCULATION = CALCULATION;
var EQUATION = 'calculation_equation';
exports.EQUATION = EQUATION;
var ROLLUP = 'calculation_rollup';
exports.ROLLUP = ROLLUP;
var SCORE = 'calculation_score';
exports.SCORE = SCORE;